import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  dashboardWidgetCardClassName,
  dashboardWidgetTitleClassName,
} from '@/components/dashboard/dashboard-widget-styles';

type DashboardWidgetCardProps = {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  headerClassName?: string;
};

export function DashboardWidgetCard({
  title,
  description,
  children,
  className,
  contentClassName,
  headerClassName,
}: DashboardWidgetCardProps) {
  return (
    <Card className={cn(dashboardWidgetCardClassName, className)}>
      <CardHeader className={cn('space-y-1 px-5 pb-2 pt-5', headerClassName)}>
        <CardTitle className={dashboardWidgetTitleClassName}>{title}</CardTitle>
        {description ? (
          <CardDescription className="text-body text-text-subtle">{description}</CardDescription>
        ) : null}
      </CardHeader>
      <CardContent className={cn('px-5 pb-5', contentClassName)}>{children}</CardContent>
    </Card>
  );
}
